import { styled } from '@mui/system';
import { PerlmanGreen } from '../../theme';

export const ButtonContainer = styled('div')(({ theme }) => ({
    [theme.breakpoints.down('md')]: {
        marginLeft: '0px',
        display: 'inline-block',
        padding: '50px 20px',
    },
}));

export const startOverButtonStyles = {
    backgroundColor: '#EEE',
    color: PerlmanGreen,
    boxSizing: 'border-box',
    borderRadius: '10px',
    boxShadow: 'none',
    fontSize: '1.14rem',
    fontWeight: '700',
    fontFamily: 'brandon-regular,sans-serif',
    textTransform: 'none',
    margin: 'none',
    padding: '8px 15px;',
    '&:hover': {
        backgroundColor: '#EEE',
        color: PerlmanGreen,
        boxShadow: '0px 0px 4px 4px #eee',
    },
};
